
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Casting`}</h1>
<p>{`Use `}<inlineCode parentName="p">{`String()`}</inlineCode>{` when casting a value to string.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Specially when casting objects, if we use the `}<inlineCode parentName="p">{`.toString()`}</inlineCode>{` method, we have to check the object exists first while `}<inlineCode parentName="p">{`String()`}</inlineCode>{` would just return undefined making it safer.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
'' + 12;
new String(12);
person.toString();

// Good
String(12);
String(person);
`}</code></pre>
<p>{`Use `}<inlineCode parentName="p">{`Number()`}</inlineCode>{` when casting a value to a number instead of `}<inlineCode parentName="p">{`parseInt`}</inlineCode>{` or `}<inlineCode parentName="p">{`parseFloat`}</inlineCode>{`.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Because its behavior is more consistent than `}<inlineCode parentName="p">{`parseInt`}</inlineCode>{` or `}<inlineCode parentName="p">{`parseFloat`}</inlineCode>{`. Also, `}<inlineCode parentName="p">{`parseInt`}</inlineCode>{` and `}<inlineCode parentName="p">{`parseFloat`}</inlineCode>{` take an additional argument that changes the base used and can lead to unwanted behavior.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
parseInt('12');     // 12
parseInt('2.2');    // 2
parseFloat('2.2');  // 2.2
parseInt('12a');    // 12
parseInt('a12');    // NaN

// Good
Number('12');       // 12
Number('2.2');      // 2.2
Number('12a');      // NaN
Number('a12');      // NaN
`}</code></pre>
<p>{`Use available `}<inlineCode parentName="p">{`Math`}</inlineCode>{` functions when casting a float number to an integer.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? They communicate intention much more explicitly.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
parseInt(12.2);    // 12

// Good
Math.trunc(12.6);  // 12
Math.ceil(12.6);   // 13
Math.floor(12.6);  // 12
Math.round(12.6);  // 13
`}</code></pre>
<p>{`Use `}<inlineCode parentName="p">{`Boolean()`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`!!`}</inlineCode>{` when casting to a boolean.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Consistency first, that's the way we use for the other types and second, to make the code easier to read since `}<inlineCode parentName="p">{`!`}</inlineCode>{` symbols sometimes get lost in the noise.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`const a = 'string'
const b = 1;
const c = null;

// Bad
!!a;  // true
!!b;  // true
!!c;  // false

// Good
Boolean(a);  // true
Boolean(b);  // true
Boolean(c);  // false
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;